module.exports = __webpack_public_path__ + "static/banner_pos_psico-a56fa2e25f7dd2f456dee97391876de1.jpg";